import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { ISpecies } from '../models/Species'
import { NotificationService } from './notification.service'

@Injectable()
export class SpeciesService {
	constructor(
		private http: HttpClient,
		private notificationService: NotificationService
	) {}

	public newSpecies({ ...payload }: ISpecies): Observable<void> {
		const options: any = this.setHeader()

		return this.http
			.post<any>(`${PATH}/species/register`, payload, {
				headers: options
			})
			.pipe(
				map(result => {
					this.notificationService.notify(result.message || 'Successo!', 200)
				})
			)
	}

	public getSpeciesSimple(): Observable<Array<ISpecies>> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/species/simple`, {
			headers: options
		}).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public getSpeciesDetails(id: string): Observable<void> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/species/${id}`, {
			headers: options
		})
	}

	public patchSpecies({ ...payload }: ISpecies): Observable<void> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/species/${payload._id}`, payload, {
				headers: options
			})
			.pipe(
				map(result => {
					this.notificationService.notify(result.message || 'Successo!', 200)
				})
			)
	}

	public deleteSpecies(id: string): Observable<void> {
		const options: any = this.setHeader()

		return this.http.delete<any>(`${PATH}/species/${id}`, {
			headers: options
		}).pipe(
			map(result => {
				this.notificationService.notify(result.message || 'Successo!', 200)
			})
		)
	}

	private setHeader(): HttpHeaders {
		const headers: HttpHeaders = new HttpHeaders({
			'Content-Type': 'application/json'
		})
		const options: HttpHeaders = headers

		return options
	}
}
